import { IconProps } from './IconProps';

export const Plus = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 1.62744V9.62744"
        stroke={props.fill ?? 'black'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 5.62744H9"
        stroke={props.fill ?? 'black'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

